import { render, staticRenderFns } from "./public-quiz-history.html?vue&type=template&id=138130cf&scoped=true&"
import script from "./public-quiz-history.js?vue&type=script&lang=js&"
export * from "./public-quiz-history.js?vue&type=script&lang=js&"
import style0 from "./public-quiz-history.scss?vue&type=style&index=0&id=138130cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138130cf",
  null
  
)

export default component.exports